import React, { useState } from 'react';
import { useTranslation } from '../i18n/useTranslation';
import { LEAVE_CHOICES, sendLeaveReason } from '../services/leaveReasonService';

/**
 * One optional question shown at cancel and at trial end. Skipping it changes nothing; it
 * never blocks or alters the billing step around it. `dark` matches the in-app modals.
 */
export default function LeaveReasonQuestion({ moment, dark = false }) {
  const { t } = useTranslation();
  const [choice, setChoice] = useState('');
  const [text, setText] = useState('');
  const [state, setState] = useState('idle');
  const fg = dark ? 'rgba(255,255,255,0.75)' : '#444';
  const border = dark ? 'rgba(255,255,255,0.15)' : '#ddd';

  if (state === 'sent') {
    return <p data-testid="leave-reason-thanks" style={{ fontSize: 13, color: fg, margin: '12px 0' }}>{t('leave.thanks')}</p>;
  }

  const submit = async () => {
    if (!choice || state === 'sending') return;
    setState('sending');
    await sendLeaveReason(moment, choice, text);
    setState('sent');
  };

  return (
    <div data-testid="leave-reason" style={{ textAlign: 'left', margin: '12px 0 16px' }}>
      <p style={{ fontSize: 13, fontWeight: 600, color: fg, margin: '0 0 8px' }}>{t('leave.question')}</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
        {LEAVE_CHOICES.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => setChoice(c)}
            aria-pressed={choice === c}
            style={{
              fontSize: 12, padding: '5px 10px', borderRadius: 14, cursor: 'pointer',
              border: `1px solid ${choice === c ? '#C9A84C' : border}`,
              background: choice === c ? 'rgba(201,168,76,0.18)' : 'transparent', color: fg,
            }}
          >
            {t(`leave.${c}`)}
          </button>
        ))}
      </div>
      {choice && (
        <>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            maxLength={1000}
            rows={2}
            placeholder={t('leave.placeholder')}
            style={{ width: '100%', boxSizing: 'border-box', fontSize: 13, padding: 8, borderRadius: 8, border: `1px solid ${border}`, background: 'transparent', color: fg, marginBottom: 6 }}
          />
          <button type="button" onClick={submit} disabled={state === 'sending'}
            style={{ fontSize: 12, fontWeight: 700, padding: '6px 14px', borderRadius: 8, border: 'none', background: '#C9A84C', color: '#1a1a2e', cursor: 'pointer' }}>
            {t('leave.send')}
          </button>
        </>
      )}
    </div>
  );
}
